"use client";

import { Input } from "@/components/ui/input";
import { SearchIcon } from "@/components/ui/search";
import { cn } from "@/lib/utils";
import { XIcon } from "lucide-react";

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  ariaLabel?: string;
  compact?: boolean;
};

export function SearchInput({ value, onChange, placeholder = "Search…", className, ariaLabel, compact = false }: SearchInputProps) {
  return (
    <div className={cn("relative", className)}>
      <SearchIcon
        size={16}
        className="pointer-events-none absolute top-1/2 left-3.5 -translate-y-1/2 text-muted-foreground"
      />
      <Input
        aria-label={ariaLabel ?? placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn("pl-10 pr-9 text-sm", compact ? "h-9 rounded-full" : "h-11 rounded-2xl")}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute top-1/2 right-3 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <XIcon className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
